import { render, staticRenderFns } from "./backBtn.vue?vue&type=template&id=5cfbeb80&scoped=true&"
var script = {}
import style0 from "./backBtn.vue?vue&type=style&index=0&id=5cfbeb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfbeb80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cfbeb80')) {
      api.createRecord('5cfbeb80', component.options)
    } else {
      api.reload('5cfbeb80', component.options)
    }
    module.hot.accept("./backBtn.vue?vue&type=template&id=5cfbeb80&scoped=true&", function () {
      api.rerender('5cfbeb80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Checkout/components/shared/backBtn.vue"
export default component.exports